var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('withdrawal-card',{staticClass:"mb-4",attrs:{"withdrawal":_vm.withdrawal}}),_c('withdrawal-status-list',{attrs:{"statuses":_vm.withdrawal.statuses}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }